import { colors } from '@vfit/shared/themes';
import styled from 'styled-components';

export const Invoice = styled.div`
  .checkbox-container p > b {
    color: ${colors.$00697c};
  }
`;
